module.exports = __webpack_public_path__ + "static/media/max-height.f68690c0.jpeg";